import { store } from '@src/store';

export default (): boolean =>
  store.getState().config.siteMeta.ui?.Command_Access_Enable &&
  !process.env.VITE_READ_ONLY_MODE;
